<template>
    <section ref="back" class="back z-1 position-relative">
		<div class="vh-100 sticky-top d-flex">
			<div class="d-flex flex-column flex-fill p-0">
				<div class="row g-0 m-0">
                    <div class="col-12">
                        <div class="px-4 d-flex align-items-center justify-content-center justify-content-md-start">
							<h1 class="display-1 fs-2 fw-bold p-3 bg-white rounded-2 text-dark ms-0 ms-lg-5">Skills</h1>
						</div>
                    </div>
				</div>
				<div class="text-white fw-lighter d-flex px-0 px-lg-5 py-2 justify-content-center justify-content-md-start">
					<span class="px-4 text-white">click on any skill to view more.</span>
				</div>
                <div class="d-none d-lg-flex flex-column vh-100 p-5" v-if="skills">
					<div class="d-flex flex-fill">
						<SkillComp v-for="project in skills" :name="project.name" :rating="project.rating" :duration="project.duration" :icon="project.icon"/>
					</div>
					<div class="bg-warnin d-flex justify-content-between">
						<div class="bg-dange px-4 d-flex flex-column">
							<small class="text-white flex-fill text-start">Badges</small>
							<div class="bg-primar p-0 d-flex">
								<div class="ps-0 pe-2 py-1 bg-warnin"><div class="p-5 bg-dange rounded shadow" :style="{
									'background-image': `url(https://i.ibb.co/rcV2VZ1/python-essentials-1-1.png)`,
									'background-position': `center`,
									'background-size': `contain`
								}"></div></div>
								<div class="ps-0 pe-2 py-1 bg-warnin"><div class="p-5 bg-dange rounded shadow" :style="{
									'background-image': `url(https://i.ibb.co/ggcYmjt/SCRUM.png)`,
									'background-position': `center`,
									'background-size': `contain`
								}"></div></div>
							</div>
						</div>
						<div class="bg-dange px-4 d-flex flex-column">
							<small class="text-white flex-fill text-end">Achievements</small>
							<div class="bg-primar p-0 d-flex">
								<div class="ps-2 pe-0 py-1 bg-warnin"><div class="p-5 bg-dange rounded shadow" :style="{
									'background-image': `url(https://i.ibb.co/dP9P0GM/image.png)`,
									'background-position': `center`,
									'background-size': `contain`
								}"></div></div>
								<div class="ps-2 pe-0 py-1 bg-warnin"><div class="p-5 bg-dange rounded shadow" :style="{
									'background-image': `url(https://i.ibb.co/xCwjvVZ/image.png)`,
									'background-position': `center`,
									'background-size': `contain`
								}"></div></div>
								<div class="ps-2 pe-0 py-1 bg-warnin"><div class="p-5 bg-dange rounded shadow" :style="{
									'background-image': `url(https://i.ibb.co/rttJHLq/image.png)`,
									'background-position': `center`,
									'background-size': `contain`
								}"></div></div>
								<div class="ps-2 pe-0 py-1 bg-warnin"><div class="p-5 bg-dange rounded shadow" :style="{
									'background-image': `url(https://i.ibb.co/cxGTmWB/image.png)`,
									'background-position': `center`,
									'background-size': `contain`
								}"></div></div>
							</div>
						</div>
					</div>
                </div>
				<div class="row mx-0 py-5 flex-fill d-flex d-lg-none">
					<SkillComp v-for="(project, index) in skills" :class="{'d-none': skillState[index]}" :name="project.name" :rating="project.rating" :duration="project.duration" :icon="project.icon"/>
				</div>
				<div class="row g-0 backdrop position-absolute w-100 h-100 z-1 d-none"> <!-- d-none -->
					<div class="col-4 d-flex align-items-center justify-content-center">
						<div class="skill-modal p-5 bg-dark rounded-3 shadow" style="background-image: url(https://lh3.googleusercontent.com/u/0/drive-viewer/AKGpihZ6690CXsld-Vhe0YQU9pAHUdraIE63C7KQ1TVRdXda2c9WILgQoheUansJ4rwwjcKF0i2RHndJovfuzpS6ofip0WdN=w1920-h912);">
							<div class="p-5"></div>
						</div>
					</div>
					<div class="skillmenu col z-2 rounded-start-5 shadow">
						<div class="d-flex flex-column">
							<div class="d-flex align-items-center">
								<i class="exit-modal bi bi-x-circle-fill fs-1 mx-2"></i>
								<h1 class="text-white my-0 mx-auto">Javascript</h1>
							</div>
							<div class="text-secondary">
								Comfort Zone - proficient In.
								classes - Object Orientation,
								factory functions,
								methods,
								prototype methods,
								modular js coding,
								document(DOM) API,
								fetch API,
								eval(aware of injections)
								...
								Still trying to learn more about its compiler/s
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        <div class="w-100 h-100 position-absolute top-0 start-0" :class="{ 'd-none' : show_skill_observers }">
            <div v-for="(skill, index) in skillState">
                <div ref="skillObserver" :index="index" class="w-100 vh-100 apply-snap-scroll border border-4 border-dark"></div>
            </div>
        </div>
    </section>
</template>
<script>
import SkillComp from '@/components/SkillComp.vue';

export default {
	name: "SkillsView",
    data(){
        return {
            skillState: [false, true, true, true, true],
            skillIndex: 0,
            show_skill_observers: false
        }
    },
	components: {
		SkillComp
	},
    mounted(){
        this.$nextTick(()=>{
            let skillObserver = this.$refs.skillObserver;
            console.log(skillObserver);

            skillObserver.forEach((elem)=>{
                this.observer = new IntersectionObserver(this.handleObserver, {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.5
                });

                this.observer.observe(elem);
            });
        })
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    methods: {
        handleObserver(event){
            event.forEach( entry => {
                let skillObserver = this.$refs.skillObserver;

                if( entry.isIntersecting ){
                    let index = +entry.target.getAttribute('index');
                    this.skillIndex = index;
                }
                skillObserver.forEach( (elem, index)=>{
                    if( this.skillIndex == index ){
                        this.skillState[index] = false;
                    } else {
                        this.skillState[index] = true;
                    }
                })
            } )
        },
        handleResize(){
            let back = this.$refs.back;

            if(window.innerWidth <= 768){
                back.style['height'] = `${500}vh`;
                this.show_skill_observers = false;
            } else {
                back.style['height'] = `${100}vh`;
                this.show_skill_observers = true;
            }
        }
    },
	computed: {
		skills(){
			return this.$store.state.skills;
		}
	}
}
</script>
<style scoped>
.back {
	height: 100vh;
}
.backdrop {
	/* background-color: red; */
	backdrop-filter: blur(10px);
}
.skillmenu {
	background-color: rgba(33, 37, 41, 0.9);
	backdrop-filter: blur(10px);
}
.exit-modal {
	cursor: pointer !important;
	cursor: copy;
}
.skill-modal {
	background-position: center;
	background-size: cover;
}
</style>
